import { render, staticRenderFns } from "./OpenCourse.vue?vue&type=template&id=5a4044fd&scoped=true"
import script from "./OpenCourse.vue?vue&type=script&lang=js"
export * from "./OpenCourse.vue?vue&type=script&lang=js"
import style0 from "./OpenCourse.vue?vue&type=style&index=0&id=5a4044fd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4044fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4044fd')) {
      api.createRecord('5a4044fd', component.options)
    } else {
      api.reload('5a4044fd', component.options)
    }
    module.hot.accept("./OpenCourse.vue?vue&type=template&id=5a4044fd&scoped=true", function () {
      api.rerender('5a4044fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/components/OpenCourse.vue"
export default component.exports